// Valor por defecto del dólar/euro por si falla el backend

export const CURRENCY_WORTH = 1200;
